export default __webpack_public_path__ + "static/media/pdf-icon.f3935add.png";